import { IImageDrawableObject, instanceOfIImageDrawableObject } from "./IImageDrawableObject";

export interface IImageObject extends IImageDrawableObject {
  isBackground: boolean;
  editingOnly: boolean;
}

export function instanceOfIImageObject(instance: any): instance is IImageObject {
  return instance
      && (instance.isBackground !== undefined)
      && (instance.editingOnly !== undefined)
      && instanceOfIImageDrawableObject<IImageObject>(instance, "image");
}
